export default __webpack_public_path__ + "static/media/switch_off.0ada413f.mp3";